module.exports = __webpack_public_path__ + "static/Q7Answer5_Pool_raphael_biscaldi-1b0b597bc3325a4c1f9315198c4038c8.jpg";